import { render, staticRenderFns } from "./SMSAuthStep01Form.vue?vue&type=template&id=a5bd930e"
import script from "./SMSAuthStep01Form.vue?vue&type=script&lang=js"
export * from "./SMSAuthStep01Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports